import { z } from 'zod';
/**
 * Resource identifiers. UUIDs (`crypto.randomUUID()` on Node 22) so no id-generation
 * dependency is needed. Ids are embedded in DynamoDB keys (`APP#{appId}`) but the key
 * design in CLAUDE.md §5 is unchanged.
 */
export const IdSchema = z.uuid();
/** Tenant identifier. Present on every item and checked on every read (§5 tenant isolation). */
export const OrgIdSchema = z.uuid();
/** Cognito `sub` of a person. Never a display name — the console resolves names separately. */
export const UserIdSchema = z.uuid();
export const IsoDateTimeSchema = z.iso.datetime();
/** Optimistic-locking counter. Starts at 1 on create and increments on every write. */
export const VersionSchema = z.number().int().positive();
/**
 * Opaque forward-only pagination cursor (an encoded DynamoDB `LastEvaluatedKey`).
 * Clients must treat it as opaque and never construct one.
 */
export const CursorSchema = z.string().min(1).max(2048);
/**
 * Shared list query parameters. Values arrive as strings from API Gateway, so `limit`
 * is coerced; anything non-numeric is rejected rather than defaulted.
 */
export const PaginationQuerySchema = z.strictObject({
    limit: z.coerce.number().int().min(1).max(100).default(25),
    cursor: CursorSchema.optional(),
});
/** Envelope for every list response. `nextCursor` absent means the last page. */
export function listResponseSchema(item) {
    return z.object({
        items: z.array(item),
        nextCursor: CursorSchema.optional(),
    });
}
/** Path parameters for the single-resource routes (`/v1/engagements/{id}`). */
export const IdPathParamsSchema = z.strictObject({ id: IdSchema });
//# sourceMappingURL=common.js.map